var _path, _mask, _path2, _mask2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 910,
    height: 10,
    viewBox: "0 0 910 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00366211 4.25L209.835 5.75L420.697 4.25",
    stroke: "#202D66"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_198_165",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.697 0H446.697V10H436.697V0Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.697 0V-1H435.697V0H436.697ZM446.697 0H447.697V-1H446.697V0ZM446.697 10V11H447.697V10H446.697ZM436.697 10H435.697V11H436.697V10ZM436.697 0V1H446.697V0V-1H436.697V0ZM446.697 0H445.697V10H446.697H447.697V0H446.697ZM446.697 10V9H436.697V10V11H446.697V10ZM436.697 10H437.697V0H436.697H435.697V10H436.697Z",
    fill: "#202D66",
    mask: "url(#path-2-inside-1_198_165)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_198_165",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.697 0H472.697V10H462.697V0Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M462.697 0V-1H461.697V0H462.697ZM472.697 0H473.697V-1H472.697V0ZM472.697 10V11H473.697V10H472.697ZM462.697 10H461.697V11H462.697V10ZM462.697 0V1H472.697V0V-1H462.697V0ZM472.697 0H471.697V10H472.697H473.697V0H472.697ZM472.697 10V9H462.697V10V11H472.697V10ZM462.697 10H463.697V0H462.697H461.697V10H462.697Z",
    fill: "#202D66",
    mask: "url(#path-4-inside-2_198_165)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M488.697 4.25L698.529 5.75L909.391 4.25",
    stroke: "#202D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDesign);
export default __webpack_public_path__ + "static/media/line-design.3aafb9091d27f93bcd4186c985fc1dd8.svg";
export { ForwardRef as ReactComponent };